<!-- The shell consumes and initializes the web component -->
<div *ngIf="translationReady" class="translation-tool-component-container">
  <learningtools-translation-tool
    [selectedText]="selectedText()"
    [authToken]="authToken()"
    [sourceLanguage]="sourceLanguage()"
    [targetLanguage]="targetLanguage()"
    [contextId]="contextId()"
    [platform]="platform()"
    [orgXid]="orgXid()"
    [personXid]="personXid()"
    [userId]="userId()"
    [epubRelease]="epubRelease()"
    [epubReleaseVersion]="epubReleaseVersion()"
    [sectionXid]="sectionXid()"
    [pageId]="pageId()"
    [chapterId]="chapterId()"
    (targetLanguageChanged)="handleTargetLanguageChange($event)"
    (translationError)="handleTranslationError($event)"
    [environment]="environment()"
    (closed)="handleClose()"
    (keydown.Escape)="$event.stopPropagation(); handleClose()"
  ></learningtools-translation-tool>
</div>
